export default {
  http: {
    timeout: '网络延时，请重试'
  }
}
